import "./ElectricStations.module.css";
import Header from "@/reusable_sections/Header";
import PatioDoorRepairServicesInSaintBasileLeGrand from "./sections/PatioDoorRepairServicesInSaintBasileLeGrand";
import LabTestingVerification from "./sections/LabTestingVerification";
import ContactSection from "./sections/ContactSection";
import ArtisanAlleySpotlight from "./sections/ArtisanAlleySpotlight";
import AntennaTechnicalSpecifications from "./sections/AntennaTechnicalSpecifications";
import Footer from "@/reusable_sections/Footer";
export default function ElectricStationsPage() {
  return <div>
      <Header />
      <PatioDoorRepairServicesInSaintBasileLeGrand />
      <ContactSection />
      <ArtisanAlleySpotlight />
      <LabTestingVerification />
      <AntennaTechnicalSpecifications />
      <Footer />
    </div>;
}